// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { array } from 'prop-types';
import { SkeletonText } from '@carbon/react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import uniqueId from 'lodash/uniqueId';

import Categories from 'Containers/Menus/Categories';

const StyledBreadcrumbs = styled.div`
  background-color: ${ props => props.theme.colors.shadowGray };
  margin-bottom: ${ props => props.hasElements ? '20px' : 0 };
  height: ${ props => props.hasElements ? '50px' : 0 };
  overflow-x: scroll;

  .wrapper {
    display: grid;
    grid-template-columns: 260px auto;
    grid-column-gap: 30px;
    height: 50px;
    align-items: center;
  }

  nav.breadcrumbs {
    display: flex;
    align-items: center;
  }

  nav.breadcrumbs > * {
    &:not(:last-of-type):after {
      position: absolute;
      top: 0;
      right: 0;
      content: '/';
      display: inline-block;
    }

    &:first-of-type {
      margin-left: 0;
      font-weight: bold !important;

      svg {
        width: 18px;
        height: 18px;
      }
    }

    &:last-of-type {
      font-weight: normal;
      margin-right: 0;
    }

    &:not(:hover) {
      text-decoration: none;
    }

    &.cds--skeleton__text {
      &:after {
        right: -13px;
      }
      height: 15px;
      max-width: 80px;
      padding: 0 0 0 83px;
      margin-right: 15px;
      overflow: visible !important;
    }

    position: relative;
    max-width: 250px;
    height: 15px;
    margin: 0 5px;
    padding-right: 15px;
    font-weight: 600;
    font-size: 0.75rem;
    line-height: 1rem;
    color: ${ props => props.theme.colors.darkGray };
    white-space: nowrap;
  }

  .CategoriesMenuButton {
    padding: 15px;

    &.isOpen {
      padding: 15px;
    }
  }

  .CategoriesMenu {
    top: 175px;
  }

  @media screen and (max-width: 1024px) {
    .wrapper > div {
      display: none;
    }
  }
`;

const BreadcrumbsComponent = memo(({ parts }) => {
  const theme = useTheme();
  return (
    <StyledBreadcrumbs className="BreadCrumbs" theme={ theme } hasElements={ parts?.length }>
      <div className="grid-container wrapper">
        <div>
          <Categories />
        </div>
        <nav className="breadcrumbs">
          { parts.map(item => {
            const to = {
              pathname: item.path
            };
            if (item.search) {
              to.search = item.search;
            }
            if (!item.id || item.skeleton) {
              return <SkeletonText key={ uniqueId() } lineCount={ 1 } />;
            }
            if (item.reload) {
              return <a key={ item.id } href={ item.path }>{ item.name }</a>;
            }
            return (
              <Link key={ item.id } to={ to }>{ item.name }</Link>
            );
          }) }
        </nav>
      </div>
    </StyledBreadcrumbs>
  );
});

BreadcrumbsComponent.propTypes = {
  parts: array,
};
BreadcrumbsComponent.displayName = 'BreadcrumbsComponent';

export default BreadcrumbsComponent;
